module.exports = __webpack_public_path__ + "static/img/logo-wcyl.523e934b.png";